import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import '../styles/AdminPanel.css';

export default function AdminPanel() {
  const { token } = useAuth();
  const API_URL = (process.env.REACT_APP_API_URL || '').replace(/^http:/, 'https:');

  const [categorias, setCategorias] = useState([]);
  const [marcas, setMarcas] = useState([]);
  const [newCat, setNewCat] = useState('');
  const [newMarca, setNewMarca] = useState('');
  const [loadingCat, setLoadingCat] = useState(false);
  const [loadingMarca, setLoadingMarca] = useState(false);
  const [errorCat, setErrorCat] = useState('');
  const [errorMarca, setErrorMarca] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [catRes, marcaRes] = await Promise.all([
          fetch(`${API_URL}/api/v1/categoria/`),
          fetch(`${API_URL}/api/v1/marca/`)
        ]);
        if (catRes.ok) setCategorias(await catRes.json());
        if (marcaRes.ok) setMarcas(await marcaRes.json());
      } catch {
        setErrorCat('Error al cargar datos.');
      }
    };
    fetchData();
  }, [API_URL]);

  const handleAddCategoria = async (e) => {
    e.preventDefault();
    if (!newCat.trim()) return;
    setLoadingCat(true);
    setErrorCat('');
    try {
      const res = await fetch(`${API_URL}/api/v1/categoria/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ nombre_categoria_vehiculo: newCat.trim() })
      });
      if (!res.ok) throw new Error();
      const created = await res.json();
      setCategorias(prev => [...prev, created]);
      setNewCat('');
    } catch {
      setErrorCat('Error al agregar categoría.');
    } finally {
      setLoadingCat(false);
    }
  };

  const handleDeleteCategoria = async (id) => {
    setErrorCat('');
    try {
      const res = await fetch(`${API_URL}/api/v1/categoria/${id}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` }
      });
      if (!res.ok) throw new Error();
      setCategorias(prev => prev.filter(c => c.id_categoria_vehiculo !== id));
    } catch {
      setErrorCat('Error al eliminar categoría.');
    }
  };

  const handleAddMarca = async (e) => {
    e.preventDefault();
    if (!newMarca.trim()) return;
    setLoadingMarca(true);
    setErrorMarca('');
    try {
      const res = await fetch(`${API_URL}/api/v1/marca/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ nombre_marca_vehiculo: newMarca.trim() })
      });
      if (!res.ok) throw new Error();
      const created = await res.json();
      setMarcas(prev => [...prev, created]);
      setNewMarca('');
    } catch {
      setErrorMarca('Error al agregar marca.');
    } finally {
      setLoadingMarca(false);
    }
  };

  const handleDeleteMarca = async (id) => {
    setErrorMarca('');
    try {
      const res = await fetch(`${API_URL}/api/v1/marca/${id}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` }
      });
      if (!res.ok) throw new Error();
      setMarcas(prev => prev.filter(m => m.id_marca_vehiculo !== id));
    } catch {
      setErrorMarca('Error al eliminar marca.');
    }
  };

  return (
    <div className="admin-panel">
      <h1>Panel de Administración</h1>
      <div className="admin-grid">
        <div className="admin-card">
          <h2>Categorías</h2>
          <form className="admin-add-form" onSubmit={handleAddCategoria}>
            <input
              type="text"
              placeholder="Nueva categoría..."
              value={newCat}
              onChange={e => setNewCat(e.target.value)}
              disabled={loadingCat}
            />
            <button type="submit" className="admin-add-btn" disabled={loadingCat || !newCat.trim()}>
              {loadingCat ? '...' : 'Agregar'}
            </button>
          </form>
          {errorCat && <p className="admin-error">{errorCat}</p>}
          <ul className="admin-list">
            {categorias.length === 0 && <li className="admin-empty">Sin categorías</li>}
            {categorias.map(cat => (
              <li key={cat.id_categoria_vehiculo} className="admin-list-item">
                <span>{cat.nombre_categoria_vehiculo}</span>
                <button
                  className="admin-delete-btn"
                  onClick={() => handleDeleteCategoria(cat.id_categoria_vehiculo)}
                  title="Eliminar"
                >
                  ×
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="admin-card">
          <h2>Marcas</h2>
          <form className="admin-add-form" onSubmit={handleAddMarca}>
            <input
              type="text"
              placeholder="Nueva marca..."
              value={newMarca}
              onChange={e => setNewMarca(e.target.value)}
              disabled={loadingMarca}
            />
            <button type="submit" className="admin-add-btn" disabled={loadingMarca || !newMarca.trim()}>
              {loadingMarca ? '...' : 'Agregar'}
            </button>
          </form>
          {errorMarca && <p className="admin-error">{errorMarca}</p>}
          <ul className="admin-list">
            {marcas.length === 0 && <li className="admin-empty">Sin marcas</li>}
            {marcas.map(m => (
              <li key={m.id_marca_vehiculo} className="admin-list-item">
                <span>{m.nombre_marca_vehiculo}</span>
                <button
                  className="admin-delete-btn"
                  onClick={() => handleDeleteMarca(m.id_marca_vehiculo)}
                  title="Eliminar"
                >
                  ×
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
